
import { actionType } from "../header/action";
import { put, takeEvery } from 'redux-saga/effects';
import common from "../../assets/lang/jp/common";
import { config } from "../../config";
function* fetchHeader() {  
  let headerPayload = (config.env !== 'localhost') ? common[config.env].header : common.header;
  try {
   
    yield put({ type: actionType.GET_HEADER_RECEIVED, payload: headerPayload });

  } catch (exception) {
     
    yield put({ type: actionType.GET_HEADER_RECEIVED, payload: {} });
  }



}
export const HeaderSagas = [
  takeEvery(actionType.GET_HEADER_REQUEST, fetchHeader)
]